import React, { useEffect } from 'react';
import ChannelForm from './ChannelForm';
import ReactGA from 'react-ga4';

import { useLocation, Link } from 'react-router-dom';
import KickLoginButton from './KickLoginButton';
import { log } from './lib/logger';

const HomeComponent = () => {
  const location = useLocation();
  const { channelData } = location.state || {};

  // Send pageview event on initial load and navigation changes
  useEffect(() => {
    const sendPageview = () => {
        ReactGA.send({ hitType: 'pageview', page: '/home' });
        log.debug('Send /home pageview');
      };

    sendPageview();

    const unlisten = () => {
      ReactGA.send({ hitType: 'pageview', page: location.pathname });
      log.debug(`Send ${location.pathname} pageview`);
    };

    window.addEventListener('popstate', unlisten);

    return () => {
      window.removeEventListener('popstate', unlisten);
    };
  }, [location.pathname]);

  return (
    <div className="home-container">
      <div className='intro'>
        <h1>Multistream Viewer for Twitch, YouTube & Kick</h1>
        <p>
          Watch multiple Twitch, YouTube & Kick live streams at the same time. TikTok live chat is also available in Chat Only Mode.
          <br />
          <br />
          Enter the live channel names you want to watch.
        </p>
      </div>
      
      {/* ChannelForm sends its own "Form Submitted" GA event */}
      <ChannelForm initialChannels={channelData} />
      <div className='login-buttons'>
        <KickLoginButton /> 
      </div>
      <div className='messages'>
        <p>* <span>Twitch & YouTube</span> use cross-site tracking to share your logged-in account across windows and tabs. Some browsers (hello Safari!) prevent cross-site tracking by default, so you may appear logged out.</p>
      </div>
      <div className='learn-more'>
        <p>
          <Link to="/about-multistream-viewer-twitch-youtube-kick">About</Link>
          {' | '}
          <a href="https://overlay.watchstreams.tv" target="_blank" rel="noreferrer">Multi Chat Overlay</a>
          {' | '}
          <a href="https://updater.watchstreams.tv" target="_blank" rel="noreferrer">Stream Info Updater</a>
        </p>
      </div>
      <div className='version-track'>
        <p>{process.env.REACT_APP_VERSION}</p>
      </div>

    </div>
  );
};

export default HomeComponent;
